@if (!isSocialInit) {
  <div fxFlex fxLayoutAlign="center center" class="fade-in">
    @if (!socialKey) {
      <div fxFlex fxLayoutAlign="center center">
        <button style="width: 220px" mat-stroked-button (click)="onCreateNewSocialKey()" [disabled]="isLoadingSocialKey || isCreatedDisabled" matTooltip="{{'general.createToken' | transloco}}">
          @if (!isLoadingSocialKey) {
            <span>
              <mat-icon style="margin-right: 10px">power</mat-icon>
              <span style="position: relative; top: -7px">{{ 'general.newSocialKey' | transloco }}</span>
            </span>
          }
          @if (isLoadingSocialKey) {
            <span>
              <app-loading [type]="6" [size]="'20px'" [style]="{'position': 'relative', 'left': '-120px', 'top': '2px'}"></app-loading>
            </span>
          }
        </button>
      </div>
    }
    @if (enterprise && socialKey) {
      <div fxLayout="column" fxLayoutAlign="start center">
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
          <button color="accent" mat-raised-button (click)="onCreateSocialURL()" [disabled]="isLoadingSocialURL" matTooltip="{{'general.socialConnections' | transloco}}">
            @if (!isLoadingSocialURL) {
              <span>
                <mat-icon>power</mat-icon>
                <!--                <span *ngIf="!miniMode" style="position: relative; top: -7px">{{ 'general.connections' | transloco }}</span>-->
              </span>
            }
            @if (isLoadingSocialURL) {
              <span>
                <app-loading [type]="6" [size]="'20px'" [style]="{'position': 'relative', 'left': '-120px', 'top': '2px'}"></app-loading>
              </span>
            }
          </button>
          <button mat-flat-button (click)="onRemoveSocialKey()" matTooltip="{{'general.disconnectSocial' | transloco}}">
            <mat-icon class="iconLarger2">power_off</mat-icon>
          </button>
          <button mat-flat-button (click)="onCreateSocialTest()" matTooltip="{{'general.testSocialConnection' | transloco}}">
            <mat-icon class="iconLarger2">lightbulb</mat-icon>
          </button>
        </div>
        <br/>
        <div style="text-align: center; position: relative; left: 30px; top: 10px">
          @if (!miniMode) {
            <button (click)="openCors()" mat-flat-button>
              <mat-icon>lightbulb</mat-icon>
              {{'general.importantNotes' | transloco}}
            </button>
          }
        </div>
      </div>
    }
    <br/>
  </div>
}
@if (enterprise && isSocialInit) {
  <div fxFlex fxLayoutAlign="center center" style="height: 60px" class="fade-in">
    <app-loading [type]="6" [size]="'20px'" [style]="{'position': 'relative', 'left': '-120px', 'top': '2px'}"></app-loading>
  </div>
}

